// import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
// import { usePaymentCompanyName } from 'all-in-one-shared-api';
import { isLocaleEnglish } from 'utils';
import download from 'assets/images/download.svg';
import { FPSPanelContent } from '../components/FPSPanelContent';
import './QrCodeModal.css'; // 引入样式文件
import { useRef } from 'react';
import html2canvas from 'html2canvas';
const QrCodeModal = ({
  policyNumberNew,
  companyCode,
  modalVisible,
  setModalVisible,
  amount,
}: {
  policyNumberNew: string;
  companyCode: string;
  modalVisible: boolean;
  setModalVisible: (modalVisible: boolean) => void;
  amount?: number | string;
}) => {
  const { t, i18n } = useTranslation();
  const isEnglish = isLocaleEnglish(i18n.language);

  // const { data: companyNameData, shouldFetch: companyNameShouldFetch } = usePaymentCompanyName(
  //   '', // 替换为适当的 token 或 auth
  //   companyCode,
  // );

  const FPS_MCC = '0000';
  const FPS_CURRENCY = '344';
  // const FPS_ID = '5169909';
  const qrCodeRef = useRef<HTMLDivElement>(null); // 用于引用二维码区域

  const handleDownloadQRCode = () => {
    if (qrCodeRef.current) {
      html2canvas(qrCodeRef.current).then((canvas) => {
        const link = document.createElement('a');
        link.href = canvas.toDataURL(); // 转换为图片URL
        link.download = 'qrcode.png'; // 设置文件名
        link.click(); // 触发下载
      });
    }
  };

  const handleClose = () => {
    setModalVisible(false);
  };

  return (
    <div className={`modal-overlay ${modalVisible ? 'show' : ''}`}>
      <div className="modal-content">
        <div className="modal-header">
          <span className="modal-title">{t('life.Payment.ScanQRcode')}</span>
          <img
            width="32"
            height="32"
            src={download}
            alt="close"
            className="close-icon"
            onClick={handleDownloadQRCode}
          />
        </div>
        <div className="qr-code-container" ref={qrCodeRef}>
          <FPSPanelContent
            mcc={FPS_MCC}
            currency={FPS_CURRENCY}
            amount={amount as string}
            fpsId={companyCode == '8' ? '5169909' : '7222417'}
            merchantName={companyCode == '8' ? 'Generali Life (Hong Kong)' : 'Assicurazioni Generali S.'}
            reference={policyNumberNew}
          />
        </div>
        <div className="modal-body">
          <div className="merchant-info">
            {/* <span>{FPS_MERCHANT_NAME}</span> */}
            <span>{t('life.Payment.MerchantName')}</span>
            <span>{t('life.Payment.PleaseNote')}</span>
          </div>
        </div>
        <div className="modal-footer">
          <button className="close-btn" onClick={handleClose}>
            {isEnglish ? 'Close' : '關閉'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default QrCodeModal;
